import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const DisabledIcon: FC<IconProps> = ({ width = 34, height = 42, ...rest }) => (
  <Icon type="Disabled" width={width} height={height} alt="People of Determination" {...rest} />
)
